import React from "react";
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { UnstyledTextAreaField, UnstiledField } from '../common/Inputs';
import { Panel, Button, Alert } from 'react-bootstrap';
import {
    getSettings as getSettingsAction,
    updateSettings as updateSettingsAction,
    clearUpdateSettings as clearUpdateSettingsAction
} from "../../actions/settings";
import * as fetchingState from '../../constants/fetchingState';

import { websiteMeta } from '../../constants/settingTypes';
import * as permissions from '../../constants/permissions';

let WebsiteMeta = class extends React.Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
        this._resetForm = this._resetForm.bind(this);
        this._load = this._load.bind(this);
    }

    _onSubmit(values) {
        this.props.updateSettingsAction(websiteMeta, values);
    }

    _resetForm() {
        this.props.clearUpdateSettingsAction(websiteMeta);
    }

    _load() {
        this.props.clearUpdateSettingsAction(websiteMeta);
        this.props.getSettingsAction(websiteMeta);
    }

    componentDidMount() {
        this.props.getSettingsAction(websiteMeta);
    }

    render() {
        const { handleSubmit, fetching, updateFetching, crudError } = this.props;
        const formVisible = fetching === fetchingState.FETCHED && updateFetching === fetchingState.INITIAL;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        return (
            <Panel>
                <Panel.Heading>Настройки страниц сайта</Panel.Heading>
                <Panel.Body>
                    {formVisible && <form className='form-horizontal'>
                        <Field disabled={isReadOnly} name='Title' component={UnstiledField} label='Title' style={{}} />
                        <Field disabled={isReadOnly} name='Description' component={UnstyledTextAreaField} label='Description' />
                        <Field disabled={isReadOnly} name='Keywords' component={UnstyledTextAreaField} label='Keywords' />
                        <div style={{ margin: '5px', marginTop: '15px', float: 'right' }}>
                            <Button disabled={isReadOnly} bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)}>Сохранить</Button>
                        </div>
                    </form>}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
                    {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
                    {updateFetching === fetchingState.FETCHING && <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {updateFetching === fetchingState.FETCHED && <div>
                        <Alert bsStyle='success'>Настройки успешно обновлены</Alert>
                        <Button bsStyle="primary" onClick={this._resetForm}>Закрыть</Button>
                    </div>}
                    {updateFetching === fetchingState.FAILED && <div>
                        <Alert bsStyle='danger'>
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                        <Button onClick={this._load}>Закрыть</Button>
                    </div>}
                </Panel.Body>
            </Panel>);
    }
}

WebsiteMeta = reduxForm({
    form: 'websiteMetaSettingsEdit',
    enableReinitialize: true
})(WebsiteMeta);

WebsiteMeta = connect(state => {
    const { data, fetching, updateFetching } = state.application.get('settings')[websiteMeta];
    return { initialValues: data, fetching, updateFetching }
}, {
    getSettingsAction,
    updateSettingsAction,
    clearUpdateSettingsAction
})(WebsiteMeta);

export default WebsiteMeta;


// WEBPACK FOOTER //
// ./src/components/settings/WebsiteMeta.jsx